<template><div id="app"><router-view /></div></template>
<script>
import './assets/styles/site.css'
export default { name: 'App' }
</script>
